/**
 * Widget settings and Iframe Settings
 * This code is under copyright Arcano Gmbh (https://arcano.app).
 *
 * - no commercial use
 * - no modifications
 * - no redistribution
 *
 * without written consent of Arcano Gmbh, zentralstrasse 47, 8003 zürich, switzerland, https://arcano.app
 */

'use strict';


import {delay} from "./utils";

function blobToBase64(blob: Blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}


function updateWidgetData(key: string, data: {}) {
    return fetch('/update_widget/' + key, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
}


async function updatePageIFrame() {
    const response = await fetch('/get_widget')

    const cdata = await response.json()
    console.log(cdata)

    const iframe = document.getElementsByTagName('iframe')[0];

    if (iframe) {

        const url = new URL(iframe.src)
        let query = new URLSearchParams(url.search)
        if ('iframe' in cdata) {
            if ('iframe_background' in cdata.iframe) {
                query.set('background_color', cdata.iframe['iframe_background'].slice(1))
            }
            if ('showPinIFrame' in cdata.iframe) {
                query.set('iframe_pin', 'optional');
            } else {
                query.delete('iframe_pin');
            }
            if('showPinIFrame' in cdata.iframe) {
                (document.getElementById('showPinIFrame') as HTMLInputElement).checked = true;
            }
            if('iframePinCheckRequired' in cdata.iframe) {
                (document.getElementById('iframePinCheckRequired') as HTMLInputElement).checked = true;
            }
            if('iframeShowFromNameCheck' in cdata.iframe) {
                (document.getElementById('iframeShowFromNameCheck') as HTMLInputElement).checked = true;
            }
            if('iframeEmailRequired' in cdata.iframe) {
                (document.getElementById('iframeEmailRequired') as HTMLInputElement).checked = true;
            }
        }
    }
}
async function updatePageUpload() {
    const response = await fetch('/get_widget')

    const cdata = await response.json()
    console.log(cdata)
    if(!('upload' in cdata)) {
        return;
    }

    if ('upload' in cdata && 'uploadLogo' in cdata['upload'] && cdata['upload']['uploadLogo']) {
        const b64Image = cdata['upload']['uploadLogo']
        renderCustomLogo(b64Image)
    }
    const showPinUpload = cdata['upload']['showPinUpload']

    if (showPinUpload) {
        (document.getElementById('showPinUpload') as HTMLInputElement).checked = true
    }
    const uploadPinCheckRequired = cdata['upload']['uploadPinCheckRequired']
    if (uploadPinCheckRequired) {
        (document.getElementById('uploadPinCheckRequired') as HTMLInputElement).checked = true
    }
    const uploadShowFromNameCheck = cdata['upload']['uploadShowFromNameCheck']
    if (uploadShowFromNameCheck) {
        (document.getElementById('uploadShowFromNameCheck') as HTMLInputElement).checked = true
    }
    const uploadEmailRequired = cdata['upload']['uploadEmailRequired']
    if (uploadEmailRequired) {
        (document.getElementById('uploadEmailRequired') as HTMLInputElement).checked = true
    }

    // if ('upload' in cdata && 'uploadLogo' in cdata['upload'] && cdata['upload']['uploadLogo']) {
    //     const b64Image = cdata['upload']['uploadLogo']
    //     renderCustomLogo(b64Image)
    //     const showPinUpload = cdata['upload']['showPinUpload']
    //     if (showPinUpload) {
    //         (document.getElementById('showPinUpload') as HTMLInputElement).checked = true
    //     }
    // }

}
async function updatePageWidget() {
    const response = await fetch('/get_widget')
    const d = await response.json()

    if ('widget' in d) {
        const button = document.getElementById('arcano-uploader-widget')

        if (button) {
            if ('buttonText' in d.widget) {
                let value = d.widget['buttonText'];
                (document.getElementById('buttonText') as HTMLInputElement).value = value
                button.textContent = value;
            }
            if ('buttonBackgroundColor' in d.widget) {
                let value = d.widget['buttonBackgroundColor'];
                (document.getElementById('buttonBackgroundColor') as HTMLInputElement).value = value;
                button.style.backgroundColor = value;
            }
            if ('buttonBorderColor' in d.widget) {
                let value = d.widget['buttonBorderColor'];
                (document.getElementById('buttonBorderColor') as HTMLInputElement).value = value;
                button.style.borderColor = value;
            }
            if ('buttonTextColor' in d.widget) {
                let value = d.widget['buttonTextColor'];
                (document.getElementById('buttonTextColor') as HTMLInputElement).value = value;
                button.style.color = value;
            }
            if ('buttonBorderRadius' in d.widget) {
                let value = d.widget['buttonBorderRadius'];
                (document.getElementById('buttonBorderRadius') as HTMLInputElement).value = value;
                button.style.borderRadius = value + 'px';
            }
            if ('buttonPadding' in d.widget) {
                let value = d.widget['buttonPadding'];
                (document.getElementById('buttonPadding') as HTMLInputElement).value = value;
                button.style.padding = value + 'px';
            }
            if ('widgetEmailRequired' in d.widget) {
                let value = d.widget['widgetEmailRequired'];
                (document.getElementById('widgetEmailRequired') as HTMLInputElement).value = value;
                button.style.padding = value + 'px';
            }


            const img = document.createElement("img")
            img.alt = "Arcano. Secure File Upload."
            img.src = 'https://arcano.app/img/logo_a.png'
            img.style.width = '16px'
            img.style.height = '16px'
            img.style.marginRight = '10px'
            img.style.marginBottom = '4px'
            img.style.verticalAlign = 'middle';
            img.style.display = 'inline-block'
            button.insertAdjacentElement('afterbegin', img)
        }

        if('showPinCheck' in d.widget) {
            (document.getElementById('showPinCheck') as HTMLInputElement).checked = true;
        }
        if('widgetPinCheckRequired' in d.widget) {
            (document.getElementById('widgetPinCheckRequired') as HTMLInputElement).checked = true;
        }
        if('showFromNameCheck' in d.widget) {
            (document.getElementById('showFromNameCheck') as HTMLInputElement).checked = true;
        }
        if('widgetEmailRequired' in d.widget) {
            (document.getElementById('widgetEmailRequired') as HTMLInputElement).checked = true;
        }

    }
}


async function updateImageDisplay(): Promise<string> {
    const input = document.getElementById('uploadLogo')! as HTMLInputElement;

    const curFiles = input.files;
    if (curFiles && curFiles.length === 1) {
        const file = curFiles[0];

        // const imageData = URL.createObjectURL(file);
        const b64Image = await blobToBase64(file) as string

        return b64Image
    }
    return ''
}


function renderCustomLogo(imageData: string) {
    const preview = document.getElementById('logoPreview')!;
    preview.innerText = '';
    if(imageData // 👈 null and undefined check
       && Object.keys(imageData).length === 0
       && Object.getPrototypeOf(imageData) === Object.prototype) {
        return;
    }
    const para = document.createElement('p');
    const image = document.createElement('img');
    image.classList.add('own-logo')
    image.src = imageData;
    para.appendChild(image);
    preview.appendChild(para);
}

export function setupReceiveSettings() {
    if(window.location.pathname.indexOf('/receive') < 0) {
        return
    }
    const widgetForm = document.getElementById('changeWidgetForm') as HTMLFormElement

    widgetForm.addEventListener('change', async function (e) {
        // @ts-ignore
        let data = Object.fromEntries(new FormData(widgetForm));
        if(data.widgetPinCheckRequired === 'true' && !data.showPinCheck) {
            data.showPinCheck = 'true'
        }
        updateWidgetData('widget', data).then(() => {
            const target = e.target as HTMLInputElement;

            if(target.name === 'showPinCheck' || target.name === 'showFromNameCheck') {
                document.location.reload()
            }
            updatePageWidget()
        })
    })
    const buttonText = document.getElementById('buttonText')
    buttonText!.addEventListener('keyup', delay(async function () {
        // @ts-ignore
        let data = Object.fromEntries(new FormData(widgetForm));
        updateWidgetData('widget', data).then(updatePageWidget)
    }, 500))

    updatePageWidget().then(() => {})

    const iframeForm = document.getElementById('changeIFrameForm') as HTMLFormElement;
    iframeForm.addEventListener('change', async function (e) {
        // @ts-ignore
        let data = Object.fromEntries(new FormData(iframeForm));

        if(data.iframePinCheckRequired === 'true' && !data.showPinIFrame) {
            data.showPinIFrame = 'true'
        }

        const iframe = document.getElementsByTagName('iframe')[0] as HTMLIFrameElement;
        iframe.contentWindow!.location.reload()
        updateWidgetData('iframe', data).then(updatePageIFrame)
    })

    const changeUploadForm = document.getElementById('changeUploadForm') as HTMLFormElement;
    changeUploadForm.addEventListener('change', async function (event) {

        const target = event.target as HTMLInputElement;
        let imageData = ""
        if(target && target.accept === 'image/*') {
            imageData = await updateImageDisplay()
        } else {
            const image = document.querySelector('#logoPreview img') as HTMLImageElement;
            imageData = image ? image.src : "";
        }

        let data = Object.fromEntries(new FormData(changeUploadForm));

        renderCustomLogo(imageData);

        if(imageData !== '') {
            data.uploadLogo = imageData
        }

        if(data.uploadPinCheckRequired === 'true' && !data.showPinUpload) {
            data.showPinUpload = 'true'
        }

        // const target = e.target as HTMLInputElement;
        updateWidgetData('upload', data).then(updatePageUpload)
    })

    updatePageIFrame().then(() => {})
    updatePageUpload().then(() => {})

}
